import { put, call, takeLatest } from "redux-saga/effects";

import * as Actions from "redux/actions/Module";
import * as Types from "redux/constants/Module";

import ModuleService from "services/ModuleService";

export function* fetchModulesEffect() {
    try {
        const { data: modules, success, message } = yield call(ModuleService.fetchModules);
        if (success) {
            yield (put(Actions.fetchModulesOk(modules.result)));
            return;
        }
        yield (put(Actions.fetchModulesFailed(message)));
    } catch ({ response }) {
        yield (
            put(
                Actions.addModuleFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: []
                })
            )
        );
    }
}

export function* addModuleEffect({ payload }) {
    try {
        yield call(ModuleService.postModule, payload);
        yield (put(Actions.addModuleOk()));
    } catch ({ response }) {
        yield (
            put(
                Actions.addModuleFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: response.data.data.errors ? response.data.data.errors : null,
                })
            )
        );
    }
}

export function* fetchModuleEffect({ payload }) {
    try {
        const { data: module } = yield call(ModuleService.fetchModule, payload);
        yield (put(Actions.fetchModuleIdOk(module)));
    } catch ({ response }) {
        yield (
            put(
                Actions.fetchModuleIdFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: []
                })
            )
        );
    }
}


export function* patchModuleEffect({ payload }) {
    try {
        yield call(ModuleService.patchModule, payload);
        yield (put(Actions.patchModuleOk()));
    } catch ({ response }) {
        yield (
            put(
                Actions.patchModuleFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: response.data.data.errors ? response.data.data.errors : null,
                })
            )
        );
    }
}

export default function* rootSaga() {
    yield takeLatest(Types.FETCH_MODULES, fetchModulesEffect);
    yield takeLatest(Types.ADD_MODULE, addModuleEffect);
    yield takeLatest(Types.FETCH_MODULE_ID, fetchModuleEffect);
    yield takeLatest(Types.PATCH_MODULE, patchModuleEffect);
}
